import React, { Component } from 'react';

import 'sass/components/score';


export const keyColorClass = (value) => {
    if ( value >= 85 )
        return 'mastery';
    else if(value >= 66 )
        return 'emerging';
    else if(value > 0)
        return 'limited';
    return 'none';
};


export default class Score extends Component {

    constructor (props) {
        super(props);
    }

    render () {
        let classname = keyColorClass(this.props.value);
        if(this.props.value2)
            classname += '-' + keyColorClass(this.props.value2);

        return (
            <span className={this.props.scoreClass}>
                <span className={this.props.textClass}>{this.props.text}</span>
                <span
                    className={`score-color-box ${this.props.boxClass} ${classname}`}
                    data-tooltip-text={this.props.tooltipText}
                    data-tooltip-position={this.props.tooltipPosition}
                    {...this.props.extraProps}
                >
                </span>
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./js/components/Score.js